import { z } from "zod";
export const numberOrStringSchema = z.string()
  .min(1, "This field is required") 
  .refine((val) => val.trim().length > 0, "This field is required");